<ng-container *transloco="let t;">
    @if (activity?.log_status === signingStatusEnum.REVOKED) {
        {{
            t("Activity log for revoke document (Activity log tab) - sender has revoke the document", {
                sender: activity?.signable?.name,
                status: activity?.log_status | documentStatusName | lowercase
            })
        }}
    } @else if(activity?.log_status === activityLogStatusEnum.Uploaded){
        {{t("Activity log uploaded file (Activity log tab) - recipient uploaded file", {recipient: activity?.signable?.name, file: activity?.attachment})}}
    } @else if(activity?.log_status === activityLogStatusEnum.Reminder){
        {{t("Activity log for send reminder (Activity log tab) - Sender sent a reminder to party", {
            sender: activity?.signable?.name, 
            party: (activity?.document?.recipient_roles || []) | sentTo
        })}}
    } @else if(activity?.log_status === activityLogStatusEnum.Expired){
        {{ t("Activity log expired message (Activity log tab) - document has expired", {
            document : roleDetail?.roleable?.visible_name ?? roleDetail?.roleable?.name
        }) }}
    } @else if(activity?.log_status === activityLogStatusEnum.ExtendDueDate){
        {{ t("Activity log extend due date message (Activity log tab) - sender has extended the due date", {
            sender: activity?.signable?.name,
        }) }}
    } @else if(activity?.log_status === activityLogStatusEnum.Updated){
        {{ t("Activity log updated message (Activity log tab) - sender has updated the document", {
            sender: activity?.signable?.name,
            document : roleDetail?.roleable?.visible_name ?? roleDetail?.roleable?.name
        }) }}
    } @else {
        {{ 
            t("Activity log sent to message (Activity log tab) - sender send document to parties", {
                sender: activity?.signable?.name,
                status: activity?.log_status | documentStatusName | lowercase,
                parties: (activity?.document?.recipient_roles || []) | sentTo
            })
        }}
    }
</ng-container>
